import { useQuery } from 'react-query';
import { getBonusList } from './Services/APIFunctions';

export const useGetBonusList = ({ onSuccess, onError, queryKey, queryParams }) => {
    return useQuery([queryKey, queryParams], getBonusList, { onSuccess, onError });
};
